/**
 * Application-wide constants
 */
export class AppConstants {
  static readonly APP_VERSION: number = 101;

  /**
   * Zone identifiers for feature release notes
   */
  static readonly ZONE_CONNECT = 'CONNECT';
  static readonly ZONE_INVOICE_PAYMENT_LINK = 'InvoicePaymentLink';
}
